import { FormControl, OutlinedInput, OutlinedInputProps } from "@mui/material";
import React, { forwardRef, memo } from "react";
import styles from "./styles.module.scss";
import clsx from "clsx";

interface InputsProps extends OutlinedInputProps {
  title?: string;
  placeholder?: string;
  name?: string;
  type?: string;
  value?: string | number;
  defaultValue?: string;
  inputRef?: any;
  errorMessage?: string | null;
  isShowError?: boolean;
  className?: string;
}

export const Inputs = memo(
  forwardRef((props: InputsProps, ref) => {
    const {
      title,
      placeholder,
      name,
      type,
      value,
      defaultValue,
      inputRef,
      errorMessage,
      isShowError,
      className,
      ...rest
    } = props;

    const { ref: refInput, ...inputProps } = inputRef || { ref: null };

    return (
      <FormControl fullWidth>
        {title && (
          <span className={`font-semibold text-base/6 ${errorMessage ? "text-[#af1c10]" : "text-gray_80"}`}>
            {title}
          </span>
        )}
        <OutlinedInput
          type={type ? type : "text"}
          placeholder={placeholder}
          fullWidth
          name={name}
          defaultValue={defaultValue}
          value={value}
          className={clsx(className, styles.inputForm)}
          {...inputProps}
          inputRef={refInput}
          sx={{
            border: errorMessage ? '1.2px solid #af1c10 !important' : "",
          }}
          {...rest}
        />
        {errorMessage && (
          <span className="text-[#af1c10] font-medium text-xs/[140%] pt-[5px]">
            {errorMessage}
          </span>
        )}
      </FormControl>
    );
  })
);
